export default __webpack_public_path__ + "static/media/115_desktop.0c8cab42.jpg";